import { createBackground, getCreativeView, renderCreativeView } from './core';
import { preloadImages } from '../lib/utils';

/**
 * Choose random creative for ab test
 */
export function getRandomShareInviteCreative() {
  return createInviteShare('invite_default');
}

/**
 * Get the image path for sharing
 */
function getInviteShareImagePath(id: string) {
  return `assets/creatives/invites/${id}.png`;
}

/**
 * Get random MESSENGER share image path
 */
function getRandomMessengerInviteShareImageUrl() {
  const files = [
    'assets/creatives/invites/2023-05-19/fb-adopt-me_2023-05-19.jpg',
    'assets/creatives/invites/2023-05-19/fb-burger-salad_2023-05-19.jpg',
    'assets/creatives/invites/2023-05-19/fb-chat-with-me_2023-05-19.jpg',
    'assets/creatives/invites/2023-05-19/fb-pet-me_2023-05-19.jpg',
    'assets/creatives/invites/2023-05-19/fb-which-do-u-choose-blue-bear_2023-05-19.jpg',
  ];
  const file = files[Math.floor(Math.random() * files.length)];
  return `${window.location.origin}/${file}`;
}

/**
 * Get random INSTAGRAM share image path
 */
function getRandomInstagramInviteShareImageUrl() {
  const files = [
    'assets/creatives/invites/2023-05-19/ig-adopt-me_2023-05-19.jpg',
    'assets/creatives/invites/2023-05-19/ig-burger-salad_2023-05-19.jpg',
    'assets/creatives/invites/2023-05-19/ig-chat-with-me_2023-05-19.jpg',
    'assets/creatives/invites/2023-05-19/ig-pet-me_2023-05-19.jpg',
    'assets/creatives/invites/2023-05-19/ig-which-do-u-choose-blue-bear_2023-05-19.jpg',
  ];
  const file = files[Math.floor(Math.random() * files.length)];
  return `${window.location.origin}/${file}`;
}

/**
 * Get random image url for sharing
 */
export function getRandomInviteShareImageUrl() {
  if (process.env.APP_ID === 'TREMBLY-MESSENGER') {
    return getRandomMessengerInviteShareImageUrl();
  } else {
    return getRandomInstagramInviteShareImageUrl();
  }
}

/**
 * Get rendered creative image by id
 */
export async function createInviteShare(id: string, w = 1024, h = 1024) {
  const superview = getCreativeView(w, h);

  const image = getInviteShareImagePath(id);

  await preloadImages([image]);

  createBackground({ superview, image });

  return renderCreativeView(id, superview);
}
